<div class="mat-dialog-container">
  <!-- 明細編輯開始 -->
  <div #head>
    <app-modal-header #modal_header [isDialog]="isDialog" [title]="title" [state]="srv.state" (onOkClick)="doOk($event)"
      (onEditAndSaveClick)="doEditAndSave($event)"
      (onCancelClick)="doCancel($event)">
    </app-modal-header>
  </div>
  <div class="jk-content">
    <div class="jk-grid-cols-4"> 
    <app-jkedit  label="單位" #WD012Com  id="WD012"  [(value)]="item.WD012" placeholder="單位"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkcombobox  label="傳送或接收" #WD090Com  id="WD090"  [(value)]="item.WD090" [items]="srv.TaxWd090List"  [required]="true"  [readonly]="isBrowse"     >
    </app-jkcombobox>
    <app-jktext  label="結帳來源單號" [value]="item.WD020"     >
    </app-jktext>
    <app-jkbtnedit  maintable="CMSMQ" item="W01" valueExpr="MQ001" displayExpr="MQ00" 
 label="結帳來源單別" #WD019Com  id="WD019"  [(value)]="item.WD019" placeholder="結帳來源單別"  [readonly]="isBrowse"     >
    </app-jkbtnedit>
    <app-jktext  label="銷貨來源單號" [value]="item.WD018"     >
    </app-jktext>
    <app-jkbtnedit  maintable="CMSMQ" item="W01" valueExpr="MQ001" displayExpr="MQ00" 
 label="銷貨來源單別" #WD017Com  id="WD017"  [(value)]="item.WD017" placeholder="銷貨來源單別"  [readonly]="isBrowse"     >
    </app-jkbtnedit>
    <app-jknumberedit  label="原幣金額" #WD016Com  id="WD016"  [(value)]="item.WD016" placeholder="原幣金額"  [readonly]="isBrowse"     >
    </app-jknumberedit>
    <app-jkedit  label="流水號" #WD015Com  id="WD015"  [(value)]="item.WD015" placeholder="流水號"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jknumberedit  label="營業稅額" #WD014Com  id="WD014"  [(value)]="item.WD014" placeholder="營業稅額"  [readonly]="isBrowse"     >
    </app-jknumberedit>
    <app-jkedit  label="相關號碼" #WD013Com  id="WD013"  [(value)]="item.WD013" placeholder="相關號碼"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="發票號碼" #WD001Com  id="WD001"  [(value)]="item.WD001" [required]="true"  placeholder="發票號碼"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jktextarea  height="250px" 
 label="備註" #WD011Com  id="WD011"  [(value)]="item.WD011" placeholder="備註"  [readonly]="isBrowse"     >
    </app-jktextarea>
    <app-jknumberedit  label="金額" #WD010Com  id="WD010"  [(value)]="item.WD010" placeholder="金額"  [readonly]="isBrowse"     >
    </app-jknumberedit>
    <app-jknumberedit  label="單價" #WD009Com  id="WD009"  [(value)]="item.WD009" placeholder="單價"  [readonly]="isBrowse"     >
    </app-jknumberedit>
    <app-jknumberedit  label="數量" #WD008Com  id="WD008"  [(value)]="item.WD008" placeholder="數量"  [readonly]="isBrowse"     >
    </app-jknumberedit>
    <app-jkedit  label="品名" #WD007Com  id="WD007"  [(value)]="item.WD007" placeholder="品名"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="發票迄號" #WD006Com  id="WD006"  [(value)]="item.WD006" placeholder="發票迄號"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="發票起號" #WD005Com  id="WD005"  [(value)]="item.WD005" placeholder="發票起號"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jktext  label="序號" [value]="item.WD004"     >
    </app-jktext>
    <app-jktext  label="申報年月" [value]="item.WD003"     >
    </app-jktext>
    <app-jkedit  label="訊息類別" #WD002Com  id="WD002"  [(value)]="item.WD002" [required]="true"  placeholder="訊息類別"  [readonly]="isBrowse"     >
    </app-jkedit>

    </div>
  </div>
</div>